'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).filter('filenameFilter', function () {
	return function (url) {
		if (url.lastIndexOf('/') < 0) {
			return url;
		}

		return url.substring(url.lastIndexOf('/') + 1);
	}
});